import { MenuItem } from "@mui/material";
import { TextFieldForm } from "@styleguide";
import { type Control, useWatch } from "react-hook-form";
import { timeSpent } from "../logics/constants";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";

export interface IModalActionFormTimeSpentProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormTimeSpent = ({ control }: IModalActionFormTimeSpentProps) => {
  const status = useWatch({
    control,
    name: "status",
  });

  if (status === "todo") {
    return null;
  }
  return (
    <TextFieldForm
      control={control}
      name="timeSpent"
      label="Temps passé"
      size="small"
      select
      SelectProps={{ MenuProps: { sx: { maxHeight: 300 } } }}
    >
      {timeSpent.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextFieldForm>
  );
};
